/**
 * 全局页面透明水印：展示部署国家码、用户名、本地时间与用户 ID。
 */
import React, { useEffect, useState } from 'react';
import { Watermark } from 'antd';

import { formatWatermarkLocalTime } from '@/components/global-watermark/format-watermark-local-time';
import style from '@/components/global-watermark/global-watermark.module.less';

export interface GlobalWatermarkProps {
  /** 部署环境对应的国家码 */
  countryCode: string;
  /** 登录用户名，来自鉴权接口 userName */
  userName: string | null;
  /** 用户 ID，来自鉴权接口 */
  userId: number | null;
  children: React.ReactNode;
}

/**
 * AI.GEN lines=1-29
 * 使用 antd Watermark 铺满可视区域；本地时间含秒、每秒刷新（频繁重绘可能带来轻微平移感）。
 *
 * @param props - 水印文案依赖的上下文与国家、用户信息
 * @returns 包裹子节点的水印容器
 */
export const GlobalWatermark = (props: GlobalWatermarkProps) => {
  const { countryCode, userName, userId, children } = props;
  const [timeStr, setTimeStr] = useState(() => formatWatermarkLocalTime());

  useEffect(() => {
    const update = () => setTimeStr(formatWatermarkLocalTime());
    update();
    const timerId = window.setInterval(update, 1000);
    return () => window.clearInterval(timerId);
  }, []);

  return (
    <Watermark
      content={[
        `${countryCode} / ${userName ?? '-'}`,
        timeStr,
        `userId: ${userId ?? '-'}`,
      ]}
      font={{
        color: 'rgba(0, 0, 0, 0.05)',
        fontSize: 13,
        fontFamily: 'monospace',
      }}
      gap={[140, 100]}
      rotate={-28}
      rootClassName={style.watermarkRoot}
    >
      <div className={style.watermarkInner}>{children}</div>
    </Watermark>
  );
};
